function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "transparent",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  d: "M1668.33,1764.28c0,0,120-75,187-204 s185-128,232-96s116,170,136,195s112,278,383,234s273-176,271-205s-38-141-93-222s-118-255,30-275c23.49-4.12,56.15-1.79,86.43,2.38 c38.79,5.34,76.94,14.55,114.01,27.15c115.19,39.13,500.16,154.04,548.55-39.52c38-166-123-197-234-232s-292-84-359-220 c-51.07-103.67-116.1-223.04-144.12-273.93c-30.94-56.19-95.22-85.89-157.8-71.79c-1.02,0.23-2.05,0.47-3.08,0.72 c-99,24-113,87-105,113s64,393,64,393s27,148-167,162s-182-112-184-134s35-188-62-228s-338-47-386,16s-67,115-83,186 s-24,109-127,123s-223,23-264-84s-45-214-61-293s-47-186-186-220s-238-73-436,24s-261,152-284,182s-86,139-35,242s158,125,192,127 s349,16,349,16s191,7,220,146s-79,152-139,181c-60,29-156,122-69,166s102,25,259-18s244,46,244,46"
});

var SvgWalkPath = function SvgWalkPath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "3840px",
    height: "2160px",
    viewBox: "0 0 3840 2160",
    enableBackground: "new 0 0 3840 2160",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalkPath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WalkPath.a0e8ab31.svg";
export { ForwardRef as ReactComponent };